import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'navigation-steps-container',
})`
  position: relative;
  display: flex;
  align-items: center;
`;

export const ScrollContainer = styled.div`
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  padding-left: 4px;
  padding-right: 4px;

  /* Hide scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ScrollButton = styled.button`
  background: #fff;
  border: 0;
  color: #0e4c87;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.16s ease;
  flex-shrink: 0;
  margin: 0 2px;
  padding: 0;

  &:hover {
    background: rgba(14, 76, 135, 0.06);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #0e4c87;

    &:disabled {
      border: 1px solid #d9d9d9;
    }
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    color: #d9d9d9;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
    fill: currentColor;
  }
`;

export const StepsWrapper = styled.div`
  display: inline-flex;
  white-space: nowrap;
  gap: 0;
`;

export default {
  Container,
  ScrollContainer,
  ScrollButton,
  StepsWrapper,
};
